<template>
  <div class="pc-info-bg">
    <img src="@/assets/images/home/pc.png" class="info-bg-pc" alt="">
    <div class="info-div">
      <img src="@/assets/images/home/pc_bg2.png" class="info-bg1" alt="">
      <div class="info2">
        <img src="@/assets/images/home/pc_bg1.png" class="info-bg2" alt="">
        <div class="info2-txt">
          <div class="txt1">可复制如下链接地址到浏览器中体验</div>
          <div class="txt2">
            https://iep.jjmc.cn/userweb
            <div class="copy-btn" @click="onCopy('https://iep.jjmc.cn/userweb')">一键复制</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {

    }
  },
  methods: {
    // 复制
    onCopy (val) {
      if (navigator.clipboard) {
        return navigator.clipboard.writeText(val).then(text => {
          this.$toast('复制成功')
        }).catch((_err) => {
          this.onExecCommand(val)
        })
      } else {
        this.onExecCommand(val)
      }
    },
    onExecCommand (val) {
      let input = document.createElement('input')
      input.setAttribute('readonly', 'readonly')
      input.setAttribute('value', val)
      input.style.position = 'absolute'
      input.style.opacity = 0
      input.style.left = '-999999px'
      input.style.top = '-999999px'
      document.body.appendChild(input)
      input.focus()
      input.select()
      input.setSelectionRange(0, 9999)
      if (document.execCommand('copy')) {
        document.execCommand('copy')
        this.$toast('复制成功')
      }
      document.body.removeChild(input)
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.pc-info-bg {
  width: 100vw;
  height: 100vh;
  position: relative;

  .info-bg-pc {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }

  .info-div {
    position: absolute;
    top: 104px;
    left: 26px;

    .info-bg1 {
      width: 323px;
      display: block;
      margin-bottom: 8px;
    }

    .info2 {
      width: 323px;
      display: block;
      position: relative;

      .info-bg2 {
        width: 100%;
        display: block;
      }

      .info2-txt {
        position: absolute;
        top: 24px;
        left: 25px;
        width: calc(100% - 50px);

        .txt1 {
          font-size: 14px;
          font-weight: 500;
          color: #fff;
          margin-bottom: 7px;
          line-height: 20px;
        }

        .txt2 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          line-height: 16px;
          font-weight: 600;
          color: #fff;
          width: 100%;

          .copy-btn {
            width: 68px;
            height: 22px;
            border-radius: 4px;
            background-color: #fff;
            font-size: 12px;
            color: #EB1700;
            font-weight: 600;
            text-align: center;
            line-height: 22px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/pcInfos.vue